import { t } from 'i18next';

export type ValidationErrors = {
  walletAddress?: string;
};

export const validateWalletAddress = (
  walletAddress: string,
): ValidationErrors => {
  const errors: ValidationErrors = {};
  if (!walletAddress.trim()) {
    errors.walletAddress = t(
      'add_wallet_modal.exchange_form.field_required_error',
    );
  }
  return errors;
};
